import { FormControl, FormControlProps } from '@chakra-ui/form-control';
import React from 'react';

export const CmFormControl: React.FC<FormControlProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <FormControl {...{ ...rest }}>{children}</FormControl>;
};
